import { Link, NavLink } from "react-router-dom";
import { useTheme } from "@/lib/theme";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

// R268www · Feb 2026 · Use the REAL Acquilix wide logo shipped in
// /public. It's a PNG (~22 KB) served from the initial static
// asset request so it appears on the first paint with no flash.
// The square version (/acquilix-square.webp) is reserved for the
// favicon, PWA icon and OG previews where a square aspect ratio
// is required.

export default function MarketingNav() {
  const { branding } = useTheme();
  const { user } = useAuth();
  return (
    <header className="border-b border-border/40 sticky top-0 bg-background/85 backdrop-blur-lg z-40">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="marketing-logo-link">
          {branding.logo_url ? (
            <img src={branding.logo_url} alt={branding.platform_name}
                  className="h-8" loading="eager" decoding="async" />
          ) : (
            <img src="/acquilix-wide.png" alt="Acquilix"
                  className="h-8" loading="eager" decoding="async"
                  data-testid="marketing-logo-default" />
          )}
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <NavLink to="/features" className="hover:text-primary transition" data-testid="nav-features">Features</NavLink>
          <NavLink to="/pricing" className="hover:text-primary transition" data-testid="nav-pricing">Pricing</NavLink>
          <NavLink to="/solutions" className="hover:text-primary transition" data-testid="nav-solutions">Solutions</NavLink>
          <NavLink to="/security" className="hover:text-primary transition" data-testid="nav-security">Security</NavLink>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <Link to="/app">
              <Button data-testid="nav-open-app-btn">Open app</Button>
            </Link>
          ) : (
            <>
              <Link to="/login" className="hidden md:inline-block text-sm hover:text-primary" data-testid="nav-login-link">
                Log in
              </Link>
              <Link to="/signup">
                <Button data-testid="nav-signup-btn">Start free</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
